import gql from 'graphql-tag';
import { BOOKING_PAYMENT_START, BOOKING_PAYMENT_SUCCESS, BOOKING_PAYMENT_ERROR } from '../../constants';

import { toastr } from 'react-redux-toastr';
import { mergeTimes } from './../../helpers/mergeTimes';
import { trackBooking } from '../../core/analytics';
import history from '../../core/history';
import { getp } from '../../helpers/getProp';

export function makePayment(
  listId,
  title,
  hostId,
  guestId,
  checkIn,
  checkOut,
  message,
  basePrice,
  discount,
  discountType,
  guestServiceFee,
  hostServiceFee,
  total,
  bookingType,
  cardId,
  guestEmail,
  units,
  promoCode,
) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: BOOKING_PAYMENT_START,
      payload: {
        paymentLoading: true,
      },
    });

    try {
      const mutation = gql`
        mutation createReservation(
          $listId: Int!
          $hostId: String!
          $checkIn: String!
          $checkOut: String!
          $units: Int!
          $basePrice: Float!
          $total: Float!
          $message: String
          $cardId: String!
          $promoCode: String
        ) {
          createReservation(
            listId: $listId
            hostId: $hostId
            checkIn: $checkIn
            checkOut: $checkOut
            units: $units
            message: $message
            basePrice: $basePrice
            total: $total
            cardId: $cardId
            promoCode: $promoCode
          ) {
            id
            listId
            hostId
            checkIn
            checkOut
            message
            basePrice
            total
            confirmationCode
            createdAt
            status
            paymentMethodId
          }
        }
      `;

      //TODO: PROMO = Get and send Promo

      // const preApprove = getState().book.bookDetails.preApprove;
      // let bookingTypeData;
      // if (preApprove === true) {
      //   bookingTypeData = 'instant';
      // } else {
      //   bookingTypeData = bookingType;
      // }

      const newDates = mergeTimes(checkIn, '11:00:00', checkOut, '11:00:00');

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId,
          hostId,
          checkIn: newDates.pickupDate._i,
          checkOut: newDates.dropoffDate._i,
          basePrice,
          total,
          message,
          units,
          cardId,
          promoCode: promoCode && promoCode.code,
        },
      });

      if (data && data.createReservation && data.createReservation.id) {
        trackBooking(listId, 'success');

        dispatch({
          type: BOOKING_PAYMENT_SUCCESS,
          payload: { paymentLoading: true },
        });

        history.push('/users/reservations/reservation/' + data.createReservation.id);
      } else {
        const errorMessage = getp(data, 'createReservation.status');
        errorMessage ? toastr.error('Failed!', errorMessage) : '';
        dispatch({
          type: BOOKING_PAYMENT_ERROR,
          payload: {
            paymentLoading: false,
            error: {
              message: 'Failed!' + errorMessage,
            },
          },
        });
      }
    } catch (error) {
      dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: {
          error,
          paymentLoading: false,
        },
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// ./src/actions/booking/makePayment.js